import { useRef as p, useState as R, useLayoutEffect as x } from "react";
const z = ({ isVisible: h, height: i, width: e, borderRadius: s }) => {
  const t = p(null), [C, g] = R();
  return x(() => {
    var c, f, o, l;
    let d = e, u = i, n = s;
    if ((c = t.current) != null && c.firstChild && (!i || !e)) {
      const r = (f = t.current) == null ? void 0 : f.firstChild, a = (l = window.getComputedStyle(
        (o = t.current) == null ? void 0 : o.firstChild
      )) == null ? void 0 : l.borderRadius;
      d = (r == null ? void 0 : r.clientWidth) + 1, u = (r == null ? void 0 : r.clientHeight) + 1, n = a === "0px" ? void 0 : a;
    }
    g({
      width: d,
      height: u,
      borderRadius: n
    });
  }, [s, i, h, e]), { sizing: C, ref: t };
};
export {
  z as useSkeleton
};
//# sourceMappingURL=index.es823.js.map
